module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/driver-report-detail/driver-report-detail.component.css
// module id = ./src/app/driver-report-detail/driver-report-detail.component.css
// module chunks = main